export enum AddressStatus {
  ADD_SUBPREMISE = 'ADD_SUBPREMISE',
  UNVERIFIED = 'UNVERIFIED',
  VERIFIED = 'VERIFIED'
}

export interface AddressValidationResponse {
  standardizedAddress: string | null;
  status: AddressStatus;
}

export interface AutocompleteResponse {
  suggestions: PlaceSuggestion[];
}

export interface PlaceSuggestion {
  placeId: string;
  mainText: string;
  secondaryText: string;
}
